import React from 'react';
import { connect } from 'react-redux';
import { LayerCreator } from '@leverege/ui-mapbox-elements';
import ZoneVehicleAdapter from "./ZoneVehicleAdapter.js";
import ZoneVehicleModel from "./ZoneVehicleModel.js";
class ZoneVehicleRenderer extends React.Component {
  constructor(props) {
    super(props);
    const {
      id,
      type
    } = props;
    this.adapter = new ZoneVehicleAdapter();
    this.points = new LayerCreator({
      id,
      // Give prefix for layer types
      dataType: type,
      // Give type of dataTypes
      adapter: this.adapter // Give adapter
    });
    this.sIds = [`${id}-fill`, `${id}-fill-selected`, `${id}-fill-rollover`, `${id}-sym`, `${id}-sym-selected`, `${id}-sym-rollover`];
  }
  render() {
    const {
      items,
      interaction,
      rollover,
      selected,
      symbols,
      order,
      model,
      map,
      ...extraData
    } = this.props;
    const isVisible = model ? ZoneVehicleModel.getVisible(model) : true;
    let isRolloverable = model ? ZoneVehicleModel.getRolloverable(model) : true;
    let isSelectable = model ? ZoneVehicleModel.getSelectable(model) : true;
    if (isVisible === false) {
      return [];
    }
    const showAt = model ? ZoneVehicleModel.getShowAtZoom(model) : null;
    const hideAt = model ? ZoneVehicleModel.getHideAtZoom(model) : null;
    const zoom = map?.getZoom() || 0;
    // console.log( this.props.relationship.path, 'zoom', zoom, 'show', showAt, 'hide', hideAt)

    // We cant do the following because the dynamic renderer will not have anything to draw
    // if ( typeof showAt === 'number' && showAt > zoom ) { return [] }
    // if ( typeof hideAt === 'number' && hideAt < zoom ) { return [] }
    if (typeof showAt === 'number' && showAt > zoom || typeof hideAt === 'number' && hideAt < zoom) {
      isRolloverable = false;
      isSelectable = false;
    }
    const opts = {
      ...extraData,
      symbols,
      rollover,
      selected,
      model,
      order
    }; // Add rollover and selected to allow highlighting
    // Add/Remove this as a selectable/rollover
    interaction[isSelectable ? 'addSelectableId' : 'removeSelectableId'](this.sIds);
    interaction[isRolloverable ? 'addRolloverId' : 'removeRolloverId'](this.sIds);

    //  console.log( 'GPR-items', this.props.relationship.path, items, this.props )
    return this.points.getLayers(items, opts);
  }
}
export default connect(() => {
  return {};
})(ZoneVehicleRenderer);